import { Button } from "@/components/ui/button";
import { Ban, Mail, LogOut } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/hooks/useAuth";

const SuspendedOverlay = () => {
    const { t } = useLanguage();
    const { signOut } = useAuth();

    const handleSignOut = async () => {
        await signOut();
        window.location.href = "/";
    };

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-background/80 backdrop-blur-md">
            <div className="max-w-md w-full bg-card p-8 rounded-2xl border border-red-200 dark:border-red-900 shadow-2xl text-center">
                <div className="w-20 h-20 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Ban className="h-10 w-10 text-red-500" />
                </div>
                <h3 className="text-2xl font-heading font-bold mb-3 text-red-600">
                    {t("ระงับการใช้งาน", "Account Suspended")}
                </h3>
                <p className="text-muted-foreground mb-6">
                    {t(
                        "บัญชีของคุณถูกระงับการใช้งาน กรุณาติดต่อ Admin เพื่อขอข้อมูลเพิ่มเติม",
                        "Your account has been suspended. Please contact Admin for more information."
                    )}
                </p>
                <div className="p-4 bg-muted/50 rounded-lg mb-6">
                    <p className="text-sm text-muted-foreground flex items-center justify-center gap-2">
                        <Mail className="h-4 w-4" />
                        {t("ติดต่อ:", "Contact:")} admin@example.com
                    </p>
                </div>
                <Button
                    variant="outline"
                    className="w-full gap-2"
                    onClick={handleSignOut}
                >
                    <LogOut className="h-4 w-4" />
                    {t("ออกจากระบบ", "Sign Out")}
                </Button>
            </div>
        </div>
    );
};

export default SuspendedOverlay;
